import { Rectangle } from '@printu/geom';
import { ViewportActionCreators } from '@printu/viewport';
import { getCurrentPage, getImage } from 'app/stores/selectors';
import { updateScaleMode } from 'app/stores/viewport/update';
import { getPageBleedBox } from '../project/page';
/*

if crop was changes as a result of history navigation we need to update viewport

 */
export const createViewportSyncMiddleware = () => store => {
    const { dispatch } = store;
    let lastPage;
    let lastBleedBox;
    let isPatching = false;
    return next => action => {
        const nextResult = next(action);
        if (isPatching) {
            return nextResult;
        }
        const state = store.getState();
        const activePage = getCurrentPage(state);
        if (activePage) {
            if (lastPage !== activePage) {
                lastPage = activePage;
                const image = getImage(state, activePage.image);
                if (image) {
                    const activeBleedBox = getPageBleedBox(activePage, image);
                    if (!lastBleedBox ||
                        !Rectangle.equal(lastBleedBox, activeBleedBox)) {
                        lastBleedBox = activeBleedBox;
                        isPatching = true;
                        try {
                            dispatch(ViewportActionCreators.setVirtualRect(activeBleedBox));
                            updateScaleMode(dispatch, store.getState);
                        }
                        catch (_) {
                            /** error */
                        }
                        isPatching = false;
                    }
                }
            }
        }
        // switch ((action as any).type) {
        //     case HistoryActions.reset.type:
        //     case HistoryActions.undo.type:
        //     case HistoryActions.redo.type:
        //         {
        //             const currentPage = getCurrentPage(store.getState());
        //             const page = getCurrentPage(store.getState());
        //             if (page) {
        //                 let viewportIsDirty = true;
        //                 if (currentPage) {
        //                     // if page has changed
        //                     if (page.id !== currentPage.id) {
        //                         // (clear fitScale)
        //                         viewportIsDirty = true;
        //                     }
        //                     // if crop on page has changed
        //                     else if (page.crop !== currentPage.crop) {
        //                         viewportIsDirty = true;
        //                     }
        //                 }
        //                 if (viewportIsDirty) {
        //                     updateViewport(
        //                         page.id,
        //                         store.dispatch,
        //                         store.getState
        //                     );
        //                 }
        //             }
        //         }
        //         break;
        //     default:
        //         break;
        // }
        return nextResult;
    };
};
